import type { CourseLeaf, CourseNavigation } from "./learning/types";

/** First actionable leaf label for "Next up" copy — never invented. */
export function nextUpFromNavigation(nav: CourseNavigation | undefined): string | null {
  if (!nav?.has_roadmap || nav.leaves.length === 0) return null;
  const next =
    nav.leaves.find((l) => l.status === "available") ??
    nav.leaves.find((l) => l.status !== "completed");
  if (!next) return null;
  return formatLeafLabel(next);
}

export function formatLeafLabel(leaf: CourseLeaf): string {
  const topic = leaf.title.trim();
  const subject = leaf.subject.trim();
  if (subject && topic) return `${subject}: ${topic}`;
  return topic || subject || "";
}

/** Roadmap completion when present; otherwise null (no fabricated %). */
export function progressPercentFromNavigation(nav: CourseNavigation | undefined): number | null {
  if (!nav?.has_roadmap) return null;
  return Math.min(100, Math.max(0, Math.round(nav.completion_percent)));
}
